import * as React from "react";
import { useTheme } from "@mui/material/styles";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { tokens } from "../theme";
import { Typography } from "@mui/material";
import { SelectIcon } from "../assets";
// import { leftArrow, SelectIcon } from "../../../assets";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function getStyles(name, personName, theme) {
  return {
    width: "100%",
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

export default function BasicSelect({ properties, width }) {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [personName, setPersonName] = React.useState([]);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(
      // On autofill we get a stringified value.
      typeof value.value === "string" ? value.value.split(",") : value.value
    );
  };

  return (
    <div>
      <FormControl sx={{ width: width || "100%", mt: 3 }}>
        <Select
          displayEmpty
          value={personName}
          onChange={handleChange}
          input={<OutlinedInput />}
          renderValue={(selected) => {
            if (selected.length === 0) {
              return (
                <Typography variant="fs14" fontWeight={500} color={"#798BA3"}>
                  Properties
                </Typography>
              );
            }

            return selected.join(", ");
          }}
          MenuProps={MenuProps}
          inputProps={{ "aria-label": "Without label" }}
          IconComponent={() => (
            <img src={SelectIcon} style={{ marginRight: "20px" }} alt="add" />
          )}
        >
          <MenuItem disabled value="">
            <Typography
              variant="fs14"
              fontWeight={400}
              color={colors.black[400]}
            >
              Properties
            </Typography>
          </MenuItem>
          {properties.length > 0 &&
            properties.map((name) => (
              <MenuItem
                key={name}
                value={name}
                style={getStyles(name.value, personName, theme)}
              >
                <Typography
                  variant="fs14"
                  fontWeight={400}
                  color={colors.black[400]}
                >
                  {name.value}
                </Typography>
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </div>
  );
}
